import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop Component
 * Automatically scrolls to the top of the page when the route changes
 * 
 * This component should be placed inside the Router context but outside
 * of the actual route components.
 */
export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Try to scroll the window first
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });

        // Also scroll any overflow containers (like the main content area)
        // Find all elements with overflow-auto or overflow-scroll
        const scrollContainers = document.querySelectorAll('.overflow-auto, .overflow-scroll, main');
        scrollContainers.forEach((container) => {
            container.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        });
    }, [pathname]);

    return null; // This component doesn't render anything
}
